/** Видеокамера и дуга траектории. Кнопка траектории камеры в 3D-сцене. */
export function CameraTrajectoryIcon({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="none"
      width="24"
      height="24"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1.5" y="1.5" width="8.12" height="6.96" rx="1.16" />
      <path d="M9.62 3.59 13.1 2.08v5.8l-3.48-1.51Z" />
      <path d="M20.2 7.95C20.2 16.2 13.2 20.5 7.15 20.5" />
      <circle cx="20.2" cy="6.4" r="1.55" />
      <circle cx="5.6" cy="20.5" r="1.55" />
    </svg>
  )
}
